import {Node, mergeAttributes} from "@tiptap/core";
import {ReactNodeViewRenderer} from "@tiptap/react";
import {CheckboxView} from "./checkbox-node-view";

export const Checkbox = Node.create({
  name: "checkbox",

  group: "inline",
  inline: true,
  selectable: false,
  atom: true,

  addAttributes() {
    return {
      checked: {
        default: false,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'input[type="checkbox"]',
      },
    ];
  },

  renderHTML({HTMLAttributes}) {
    return [
      "input",
      mergeAttributes(HTMLAttributes, {
        type: "checkbox",
        contenteditable: "false",
        disabled: "true",
      }),
    ];
  },

  addCommands() {
    return {
      insertCheckbox:
        (checked = false) =>
        ({chain}) => {
          return chain()
            .insertContent({
              type: this.name,
              attrs: {checked},
            })
            .run();
        },

      toggleCheckbox:
        () =>
        ({state, dispatch}) => {
          const {selection} = state;
          const node = state.doc.nodeAt(selection.from);

          if (node?.type.name !== this.name) return false;

          dispatch(
            state.tr.setNodeMarkup(selection.from, undefined, {
              checked: !node.attrs.checked,
            })
          );

          return true;
        },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(CheckboxView);
  },
});
